import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { routePath } from '../routing/helpers/router';
import LoginScreen from '../screens/Home/LoginScreen';
import UserAccessCodeLoginScreen from '@/screens/Home/UserAccessCodeLoginScreen';
import Verify2faScreen from '@/screens/Home/Verify2faScreen';
import AuthClientBaseScreen from '@/screens/Home/AuthClient/AuthClientBaseScreen';
import RememberPasswordScreen from '@/screens/Home/RememberPasswordScreen';
import ImpersonateScreen from '@/screens/Home/ImpersonateScreen';
import SsoLoginScreen from '@/screens/Home/SsoLoginScreen';
import RememberPasswordSetScreen from '@/screens/Home/RememberPasswordSetScreen';

export default function PublicMainContainer() {
  return (
    <Container>
      <Routes>
        {/* BASE */}
        <Route path={routePath('user_login')} exact element={<LoginScreen />} />
        <Route
          path={routePath('user_2fa_challenge')}
          exact
          element={<Verify2faScreen />}
        />
        <Route
          path={routePath('user_impersonate')}
          exact
          element={<ImpersonateScreen />}
        />
        {/* REMEMBER PASSWORD */}
        <Route
          path={routePath('user_remember_password')}
          exact
          element={<RememberPasswordScreen />}
        />
        <Route
          path={routePath('user_remember_password_set')}
          exact
          element={<RememberPasswordSetScreen />}
        />
        {/* USER ACCESS CODE */}
        <Route
          path={routePath('user_access_code_login')}
          exact
          element={<UserAccessCodeLoginScreen />}
        />
        {/* USER AUTH CLIENT  */}
        <Route
          path={routePath('user_auth_client')}
          exact
          element={<AuthClientBaseScreen />}
        />
        {/* SSO */}
        <Route
          path={routePath('user_sso')}
          exact
          element={<SsoLoginScreen />}
        />
        <Route path="*" element={<></>} />
      </Routes>
    </Container>
  );
}

const Container = styled.div`
  margin-left:0;
  transition: margin-left ease 0.3s;
`;
